export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "1": "",
        "2": "",
        "3": "",
        "4": "",
        "5": "",
        "6": "",
        "7": "",
        "8": "",
        "9": "",
        "10": "",
        "{filled} z {total} uzupełnionych": "",
        "%0 rozpoczętych checkoutów": "",
        "1 dzień": "",
        "14 dni": "",
        "3 dni": "",
        "7 dni": "",
        "Adres dostawy": "",
        "Adres e-mail": "",
        "Adres faktury": "",
        "Adres feedu": "",
        "Adres IP": "",
        "Aktualizuj cennik": "",
        "Aktywna": "",
        "Aktywne": "",
        "Aktywność promocji": "",
        "Aktywny": "",
        "Alert": "",
        "alertów": "",
        "Anulowana": "",
        "Anulowane": "",
        "Anuluj": "",
        "Anuluj edycję": "",
        "API Key": "",
        "API Key Location": "",
        "API Key Tracking": "",
        "Atrybuty": "",
        "Atrybuty i zawartość tego elementu są powtarzane dla każdego wpisu z wybranej listy (np. url → URL zdjęcia).": "",
        "Automatyczna akceptacja": "",
        "Automatycznie tworzone podsumowanie opinii o produkcie.": "",
        "Autor": "",
        "Autor opinii": "",
        "Bez adresu email": "",
        "Bez wyboru eksport obejmie wszystkie produkty.": "",
        "Bez wybranego źródła lista będzie iterować po głównej kolekcji danych.": "",
        "Bieżący okres": "",
        "Bieżący stan produktu w magazynie.": "",
        "Brak": "",
        "Brak cech dla wybranych kategorii.": "",
        "Brak cech w grupie": "",
        "Brak cech wariantowych w kategoriach tego produktu.": "",
        "Brak cenników. Dodaj cennik dla wybranego sklepu.": "",
        "Brak danych": "",
        "Brak dostępnych dostaw dla wybranego kraju.": "",
        "Brak dostępnych krajów.": "",
        "Brak katalogów": "",
        "Brak kategorii nadrzędnej": "",
        "Brak kategorii w grupie": "",
        "Brak komentarza": "",
        "Brak krajów": "",
        "Brak kwoty do rozliczenia.": "",
        "Brak miasta": "",
        "Brak odziedziczonych cech.": "",
        "Brak pasujących kategorii.": "",
        "Brak produktów komplementarnych.": "",
        "Brak produktów rekomendowanych.": "",
        "Brak produktów w kolekcji": "",
        "Brak produktów w promocji": "",
        "Brak skonfigurowanej zawartości.": "",
        "Brak tłumaczenia": "",
        "Brak treści opinii": "",
        "Brak w magazynie": "",
        "Brak witryn do przypisania.": "",
        "Brak wybranych etykiet": "",
        "Brak wybranych producentów": "",
        "Brak wybranych produktów": "",
        "Brak wybranych wartości": "",
        "Brak zdjęcia": "",
        "Brak zmian statusu.": "",
        "Brakuje części lub elementów zestawu": "",
        "Brutto": "",
        "Cecha": "",
        "Cecha nie ma jeszcze żadnych wartości.": "",
        "Cecha służy do rozróżniania wariantów produktu. Ustawienie można wybrać tylko przy tworzeniu cechy.": "",
        "Cecha została dodana.": "",
        "Cecha została usunięta.": "",
        "Cecha została zaktualizowana.": "",
        "Cechy": "",
        "Cechy odziedziczone po kategoriach nadrzędnych": "",
        "Cechy w grupie": "",
        "Cena aktualna": "",
        "Cena aktualna brutto": "",
        "Cena aktualna netto": "",
        "Cena brutto": "",
        "Cena brutto do": "",
        "Cena brutto od": "",
        "Cena do": "",
        "Cena dostawy": "",
        "Cena łączna": "",
        "Cena netto": "",
        "Cena netto do": "",
        "Cena netto od": "",
        "Cena od": "",
        "Cena produktów": "",
        "Cena sugerowana brutto": "",
        "Cena sugerowana dla wybranych produktów z zestawu": "",
        "Cena sugerowana netto": "",
        "Cena zamówienia": "",
        "Cena została zdezaktywowana.": "",
        "Cennik został dodany.": "",
        "Cennik został zaktualizowany": "",
        "Cenniki": "",
        "Ceny": "",
        "Ceny bazowe produktu w dostępnych walutach.": "",
        "Ceny dostawy": "",
        "Ceny elementów zestawu": "",
        "Ceny w pozostałych walutach przeliczane są względem domyślnej.": "",
        "Client ID": "",
        "Client Secret": "",
        "Co n-ty produkt gratis": "",
        "CRC": "",
        "Customer ID": "",
        "Cykl życia koszyka": "",
        "Czas dostawy": "",
        "Czas na zgłoszenie reklamacji": "",
        "Czas na zgłoszenie zwrotu": "",
        "Czas realizacji oraz dni i godziny wysyłki zamówień.": "",
        "Członkowie grupy klientów": "",
        "Czy na pewno chcesz usunąć ten atrybut?": "",
        "Czy na pewno chcesz usunąć ten element?": "",
        "Czy na pewno chcesz usunąć ten warunek?": "",
        "Dane adresowe zapisane w zamówieniu.": "",
        "Dane do faktury": "",
        "Dane dokumentu i rozliczenie należności.": "",
        "Dane faktury": "",
        "Dane grupy": "",
        "Dane klienta": "",
        "Dane kraju": "",
        "Dane połączenia z operatorem dostawy.": "",
        "Dane sklepu oraz sposób prezentacji cen.": "",
        "Dane zostały zapisane": "",
        "Darmowa dostawa": "",
        "Darmowa dostawa od kwoty (brutto)": "",
        "Darmowa przesyłka od kwoty (brutto)": "",
        "Darmowy produkt": "",
        "Data": "",
        "Data do": "",
        "Data dodania": "",
        "Data modyfikacji": "",
        "Data modyfikacji pliku": "",
        "Data oceny": "",
        "Data od": "",
        "Data ostatniego zamówienia": "",
        "Data płatności": "",
        "Data reklamacji": "",
        "Data rozpoczęcia": "",
        "Data rozpoczęcia publikacji jest wymagana": "",
        "Data rozpoczęcia rekomendacji": "",
        "Data ustawienia": "",
        "Data utworzenia": "",
        "Data zakończenia": "",
        "Data zakończenia rekomendacji": "",
        "Data zamówienia": "",
        "Data zmiany ceny": "",
        "Dev": "",
        "Dezaktywacja ceny jest nieodwracalna, a zdezaktywowana cena nie będzie brana pod uwagę przy obliczaniu najniższej ceny.": "",
        "Dezaktywacja zmiany ceny": "",
        "Dezaktywuj": "",
        "Dezaktywuj zmianę ceny": "",
        "Dhl": "",
        "Długość kodu": "",
        "dni": "",
        "Do wysłania": "",
        "Dodaj": "",
        "Dodaj atrybut": "",
        "Dodaj cechę": "",
        "Dodaj cechę do grupy": "",
        "Dodaj cennik": "",
        "Dodaj eksport": "",
        "Dodaj element": "",
        "Dodaj etykietę": "",
        "Dodaj fakturę": "",
        "Dodaj grupę cech": "",
        "Dodaj grupę klientów": "",
        "Dodaj katalog": "",
        "Dodaj katalog, aby rozpocząć zarządzanie kategoriami.": "",
        "Dodaj kategorię": "",
        "Dodaj kody": "",
        "Dodaj kolekcję": "",
        "Dodaj kraj": "",
        "Dodaj notatkę": "",
        "Dodaj parametr UTM": "",
        "Dodaj pierwszy element struktury.": "",
        "Dodaj poniżej": "",
        "Dodaj powiadomienie": "",
        "Dodaj powiązanie": "",
        "Dodaj powyżej": "",
        "Dodaj producenta": "",
        "Dodaj produkt": "",
        "Dodaj produkt do kolekcji": "",
        "Dodaj promocję": "",
        "Dodaj promocję wiązaną": "",
        "Dodaj przecenę": "",
        "Dodaj sklep": "",
        "Dodaj sposób dostawy": "",
        "Dodaj sposób płatności": "",
        "Dodaj stawkę": "",
        "Dodaj użytkownika": "",
        "Dodaj walutę": "",
        "Dodaj wartość": "",
        "Dodaj warunek": "",
        "Dodaj wewnątrz": "",
        "Dodaj właściwość": "",
        "Dodaj wpis w kalendarzu": "",
        "Dodaj zakres": "",
        "Dodane przez": "",
        "Dodanie cechy": "",
        "Dodanie cennika": "",
        "Dodanie eksportu": "",
        "Dodanie etykiety": "",
        "Dodanie faktury": "",
        "Dodanie grupy cech": "",
        "Dodanie grupy klientów": "",
        "Dodanie kategorii": "",
        "Dodanie kolekcji": "",
        "Dodanie kraju": "",
        "Dodanie opcji dostawy": "",
        "Dodanie opcji płatności": "",
        "Dodanie parametru UTM": "",
        "Dodanie powiadomienia": "",
        "Dodanie producenta": "",
        "Dodanie produktu": "",
        "Dodanie promocji kodów rabatowych": "",
        "Dodanie promocji wiązanej": "",
        "Dodanie przeceny produktów": "",
        "Dodanie sklepów": "",
        "Dodanie stawki": "",
        "Dodanie waluty": "",
        "Dodanie wartości": "",
        "Dodanie wpisu do kalendarza": "",
        "Dodano do koszyka": "",
        "Dodatkowe informacje o przeznaczeniu grupy.": "",
        "Dodatkowe materiały wizualne kolekcji.": "",
        "Dodatkowe objaśnienie wartości. Treść można przygotować osobno dla każdego języka.": "",
        "Dodatkowe pola dla reklamacji": "",
        "Dodatkowe wymagania dotyczące dostawy.": "",
        "Dodawaj, edytuj i porządkuj wartości.": "",
        "Dodawanie elementów": "",
        "Dodawanie kodów": "",
        "Dodawanie produktów, wybór kategorii lub import CSV.": "",
        "Dokonaj dopłaty": "",
        "Dokument faktury w formacie PDF.": "",
        "Dokument jest pusty": "",
        "Dokumenty i pliki do pobrania, maksymalnie 10 plików.": "",
        "Domyślna waluta": "",
        "Domyślny limit (brutto)": "",
        "Dopłać": "",
        "Dopłacenie faktury": "",
        "Dostawa": "",
        "Dostawa na palecie": "",
        "Dostawa w godzinach wieczornych": "",
        "Dostawa w sobotę": "",
        "Dostawie nie przypisano żadnych form płatności": "",
        "Dostawy": "",
        "Dostawy dla wybranego kraju oraz przypisane do nich formy płatności.": "",
        "Dostawy dostępne w kraju wybranego sklepu.": "",
        "Dostawy i płatności": "",
        "Dostępna liczba kodów możliwych do wygenerowania:": "",
        "Dostępne metody płatności": "",
        "Dostępność i ilości": "",
        "Dostępność kolekcji w sklepie.": "",
        "Dostępny w magazynie": "",
        "Dotpay": "",
        "Dotyczy niezalogowanych klientów.": "",
        "Drugi klucz (MD5)": "",
        "Działania masowe": "",
        "Dzień wysyłki": "",
        "E-mail": "",
        "EAN-13": "",
        "Edycja": "",
        "Edycja cechy": "",
        "Edycja cennika": "",
        "Edycja eksportu": "",
        "Edycja etykiety": "",
        "Edycja grupy cech": "",
        "Edycja grupy klientów": "",
        "Edycja kategorii": "",
        "Edycja kodu rabatowego": "",
        "Edycja kolekcji": "",
        "Edycja kraju": "",
        "Edycja opcji dostawy": "",
        "Edycja opcji płatności": "",
        "Edycja parametru UTM": "",
        "Edycja powiadomienia": "",
        "Edycja producenta": "",
        "Edycja produktu": "",
        "Edycja promocji kodów rabatowych": "",
        "Edycja promocji wiązanej": "",
        "Edycja przeceny": "",
        "Edycja przeceny produktów": "",
        "Edycja sklepów": "",
        "Edycja stawki": "",
        "Edycja stawki podatku": "",
        "Edycja waluty": "",
        "Edycja wartości": "",
        "Edycja wpisu do kalendarza": "",
        "Edytuj": "",
        "Edytuj adres": "",
        "Edytuj notatkę": "",
        "Edytuj treść": "",
        "Edytuj treść opinii": "",
        "Efekt": "",
        "Efekty promocji": "",
        "Eksport kodów rabatowych został uruchomiony": "",
        "Eksport został dodany.": "",
        "Eksport został usunięty.": "",
        "Eksport został zaktualizowany.": "",
        "Eksportuj": "",
        "Eksportuj CSV": "",
        "Eksporty": "",
        "Element": "",
        "Element nie posiada jeszcze żadnych atrybutów": "",
        "Element nie posiada jeszcze żadnych warunków": "",
        "Elementy zestawu": "",
        "Etykieta": "",
        "Etykieta priorytetowa": "",
        "Etykieta produktu została dodana.": "",
        "Etykieta produktu została usunięta.": "",
        "Etykieta produktu została zaktualizowana.": "",
        "Etykiety": "",
        "Etykiety produktów": "",
        "Etykiety wyróżniające ten produkt w sklepie.": "",
        "Faktura": "",
        "Faktura rozliczona w całości": "",
        "Faktura została dodana.": "",
        "Faktura została zaktualizowana.": "",
        "Fakturę utwórz z poziomu zamówienia.": "",
        "Faktury": "",
        "Fałsz": "",
        "Firma": "",
        "Filtry produktów": "",
        "Format": "",
        "Format cen i progi naliczania kosztów dostawy.": "",
        "Format ceny": "",
        "Format i źródło określają strukturę feedu.": "",
        "Format kodu pocztowego": "",
        "Format kodu powinien być wyrażeniem regularnym.": "",
        "Formularz": "",
        "Formy płatności powiązane z tą metodą dostawy.": "",
        "Galeria zdjęć produktu, maksymalnie 10 plików.": "",
        "Generowanie feedu zostało uruchomione.": "",
        "Generowanie kodów": "",
        "Generowanie korzysta z ostatnio zapisanej konfiguracji.": "",
        "Generowanie, dopisywanie i obsługa indywidualnych kodów.": "",
        "Generuj nowe kody": "",
        "Generuj opis": "",
        "Generuj opis produktu na podstawie parametrów": "",
        "Generuj warianty": "",
        "Generuj wszystkie metadane": "",
        "Głębokość": "",
        "Głębokość paczki": "",
        "Godzina rozpoczęcia": "",
        "Godzina wysyłki": "",
        "Godzina wysyłki: {day}": "",
        "Godzina zakończenia": "",
        "Grafika identyfikująca sposób płatności w sklepie.": "",
        "Grafika reprezentująca kolekcję.": "",
        "Grafika wyświetlana przy tej metodzie dostawy.": "",
        "Grafiki wykorzystywane do prezentacji kategorii.": "",
        "Grupa cech": "",
        "Grupa cech została dodana.": "",
        "Grupa cech została usunięta.": "",
        "Grupa cech została zaktualizowana.": "",
        "Grupa klientów": "",
        "Grupa klientów aktywna": "",
        "Grupa klientów została dodana.": "",
        "Grupa klientów została usunięta.": "",
        "Grupa klientów została zaktualizowana.": "",
        "Grupy cech": "",
        "Grupy klientów": "",
        "Happy hours": "",
        "Hasło użytkownika": "",
        "Historia faktur": "",
        "Historia powiadomień": "",
        "Historia przeglądania produktów": "",
        "Historia przeglądanych produktów": "",
        "Historia statusów": "",
        "Historia wersji": "",
        "Historia zamówień powiązanych z tym klientem.": "",
        "Historia zmian cen produktu": "",
        "Historia zmian ceny": "",
        "Id": "",
        "ID": "",
        "ID autora": "",
        "ID katalogu": "",
        "ID kategorii głównej": "",
        "ID kategorii nadrzędnej": "",
        "ID organizacji": "",
        "ID podatku": "",
        "Id punktu płatności (pos_id)": "",
        "ID sklepu": "",
        "ID użytkownika": "",
        "ID użytkownika modyfikującego": "",
        "Identyfikator i wartości używane do oznaczania ruchu.": "",
        "Identyfikator klienta w koncie DHL.": "",
        "Identyfikator organizacji w koncie InPost.": "",
        "Identyfikator sklepu (domyślnie id sprzedawcy)": "",
        "Identyfikator sprzedawcy": "",
        "Identyfikator używany do rozpoznawania grupy w systemie.": "",
        "Identyfikatory": "",
        "Ikona wartości": "",
        "Ilość": "",
        "Ilość dni po porzuceniu koszyka": "",
        "Ilość ocen": "",
        "Ilość polubień": "",
        "Ilość porzuconych koszyków": "",
        "Ilość powtórzeń po wystąpieniu błędu": "",
        "Ilość produktu pozostawiana w magazynie. Pierwszeństwo ma ustawienie wariantu, następnie produktu, a na końcu kategorii.": "",
        "Ilość produktu w zestawie": "",
        "Ilość reklamacji": "",
        "Ilość reklamowana": "",
        "Ilość w magazynie": "",
        "Ilość w magazynie do": "",
        "Ilość w magazynie od": "",
        "Ilość zamówień": "",
        "Ilość zwracana": "",
        "Ilości zarezerwowane w zamówieniach.": "",
        "Imię": "",
        "Imię i nazwisko": "",
        "Imię klienta": "",
        "Import CSV kategorii": "",
        "Import CSV produktów": "",
        "Import CSV zastąpi bieżącą listę produktów.": "",
        "Import kategorii został rozpoczęty.": "",
        "Import produktów został rozpoczęty.": "",
        "Importuj": "",
        "Importuj CSV": "",
        "Importuj schemat": "",
        "Indywidualny": "",
        "Informacja dla klienta przy wyborze tej metody dostawy.": "",
        "Informacje o produkcie": "",
        "Informacyjna": "",
        "Inny powód": "",
        "Inny problem z produktem": "",
        "Inpost": "",
        "Iteracja nastąpi po głównej kolekcji danych": "",
        "Iteracja po...": "",
        "Jakość produktu nie spełnia oczekiwań": "",
        "Jednostka marginesu": "",
        "Jednostka marginesu ilościowego": "",
        "Jeśli nazwa wyświetlana nie zostanie ustawiona, zostanie użyta nazwa kategorii.": "",
        "Jeśli nie wybrano żadnego produktu, promocja obejmuje wszystkie produkty bez żadnych ograniczeń.": "",
        "Język": "",
        "Języki witryny {name}": "",
        "JSON konfiguracji": "",
        "JSON nie jest zgodny z konfiguracją eksportu (name, source, format, schema).": "",
        "Kalendarz": "",
        "Kampania (utm_campaign)": "",
        "Kampanie": "",
        "Katalog": "",
        "Katalog jest pusty.": "",
        "Katalog kategorii": "",
        "Katalog produktów": "",
        "Katalog z kategoriami został skopiowany.": "",
        "Katalog został usunięty.": "",
        "Katalog został utworzony.": "",
        "Katalogi kategorii": "",
        "Kategoria": "",
        "Kategoria główna": "",
        "Kategoria nadrzędna": "",
        "Kategoria widoczna": "",
        "Kategoria została dodana.": "",
        "Kategoria została usunięta.": "",
        "Kategoria została zaktualizowana.": "",
        "Kategorie": "",
        "Kategorie, reguła podatku i producent.": "",
        "Kategoryzacja": "",
        "Klienci": "",
        "Klient": "",
        "Kliknij kategorię w drzewie po lewej, aby skonfigurować jej ustawienia, cechy i metadane.": "",
        "Klucz API do śledzenia przesyłek.": "",
        "Klucz API punktów odbioru DHL.": "",
        "Klucz dostępu do API obsługującego przesyłki DHL.": "",
        "Kod": "",
        "Kod ISO": "",
        "Kod pocztowy": "",
        "Kod promocyjny": "",
        "Kod rabatowy": "",
        "Kod, symbol i zasady przeliczania cen.": "",
        "Kodowanie (encoding)": "",
        "Kody identyfikujące produkt i jego pochodzenie.": "",
        "Kody promocyjne zostały dodane.": "",
        "Kody promocyjne zostały wygenerowane.": "",
        "Kody rabatowe": "",
        "Kody zostały zdezaktywowane.": "",
        "Kolejność wartości została zapisana.": "",
        "Kolekcja": "",
        "Kolekcja aktywna": "",
        "Kolekcja została dodana.": "",
        "Kolekcja została usunięta.": "",
        "Kolekcja została zaktualizowana.": "",
        "Kolekcje": "",
        "Kolekcje, do których należy produkt.": "",
        "Kolor / wzór nie odpowiada": "",
        "Kolor dekoracji tekstu": "",
        "Kolor obramowania": "",
        "Kolor tekstu": "",
        "Kolor tła": "",
        "Kolory": "",
        "Kolory tła, tekstu, obramowania i dekoracji.": "",
        "Kolumna": "",
        "Kolumna ID musi zawierać dodatnie identyfikatory produktów.": "",
        "Kolumna importu": "",
        "Kolumna używana do wczytywania produktów": "",
        "Komentarz": "",
        "Komentarz do zamówienia": "",
        "Kończy się na": "",
        "Konfiguracja": "",
        "Konfiguracja eksportu została załadowana.": "",
        "Konfiguracja wybranego operatora płatności.": "",
        "Konfiguruj kategorię": "",
        "Kopiuj": "",
        "Kopiuj adres": "",
        "Kopiuj katalog z kategoriami": "",
        "Kopiuj punkt odbioru": "",
        "Koszt dostawy": "",
        "Koszt dostawy w państwach": "",
        "Koszt dostawy: {country}": "",
        "Koszt płatności": "",
        "Koszt płatności brutto": "",
        "Koszt płatności: {country}": "",
        "Koszty wysyłki": "",
        "Koszyk usuwany": "",
        "Koszyk uznany za opuszczony": "",
        "Koszyki": "",
        "Kraj": "",
        "Kraj określa dostępne stawki podatku oraz sposoby dostawy i płatności.": "",
        "Kraj produkcji": "",
        "Kraj rozliczenia i reguła podatku dla kosztów dostawy.": "",
        "Kraj rozliczenia kosztów dostawy. Po utworzeniu nie można go zmienić.": "",
        "Kraj został dodany.": "",
        "Kraj został usunięty.": "",
        "Kraj został zaktualizowany.": "",
        "Kraje": "",
        "Kraje produkcji": "",
        "Krótki opis prezentowany przy produkcie.": "",
        "Krótki opis wartości…": "",
        "Krótki opis, który ułatwi administratorom rozpoznanie przeznaczenia sklepu.": "",
        "Kurs": "",
        "Kurs podawany za tyle jednostek waluty.": "",
        "Kurs względem waluty domyślnej, podawany dla liczby jednostek określonej mnożnikiem.": "",
        "Kwota": "",
        "Kwota brutto": "",
        "Kwota dopłaty": "",
        "Kwota netto": "",
        "Kwotowy": "",
        "Łącznie": "",
        "Legacy": "",
        "Liczba": "",
        "Liczba dni od ostatniej aktywności klienta.": "",
        "Liczba dni przechowywania": "",
        "Liczba kategorii głównych": "",
        "Liczba nowych kodów": "",
        "Liczba użyć": "",
        "Liczba wyników": "",
        "Liczba wyświetlanych produktów": "",
        "Liczba zamówień": "",
        "Liczony od utworzenia rezerwacji. Wpisz co najmniej 1 minutę.": "",
        "Liczony od zmiany statusu zamówienia na Zrealizowane.": "",
        "Limit czasowy rezerwacji": "",
        "Limit kupiecki": "",
        "Limity logistyczne": "",
        "Link do pełnej dokumentacji": "",
        "Lista": "",
        "Logo": "",
        "Logo i płatności": "",
        "Logo sposobu płatności": "",
        "Logo, zdjęcie i pliki producenta.": "",
        "Lub (or)": "",
        "Lub wpisz wartość": "",
        "Lub wybierz kolumnę CSV": "",
        "Maksimum logistyczne": "",
        "Maksymalna liczba pozycji przechowywanych w historii.": "",
        "Maksymalna liczba produktów": "",
        "Maksymalna liczba użyć": "",
        "Maksymalna wartość rabatu": "",
        "Maksymalna wartość zamówienia": "",
        "Maksymalny poziom logistyczny zapasu produktów.": "",
        "Margines dla produktów": "",
        "Margines ilościowy": "",
        "Marketing": "",
        "Media": "",
        "Medium (utm_medium)": "",
        "Metadane": "",
        "Miasto": "",
        "min": "",
        "Miniaturka": "",
        "Minimalna i maksymalna ilość produktu.": "",
        "Minimalny poziom logistyczny zapasu produktów.": "",
        "Minimum logistyczne": "",
        "Mniejsze lub równe": "",
        "Mniejsze niż": "",
        "Mnożnik": "",
        "Moduł dostawy": "",
        "Moduł płatności": "",
        "Modułu nie można zmienić po utworzeniu.": "",
        "MPN": "",
        "Multimedia": "",
        "Na status": "",
        "Nadkreślenie": "",
        "Najgłębszy poziom kategorii, na którym mają pojawić się kafelki.": "",
        "Najniższa cena z 30 dni brutto": "",
        "Najpierw wybierz wariant przeliczenia": "",
        "Najpierw zapisz wprowadzone zmiany": "",
        "Nazwa": "",
        "Nazwa atrybutu": "",
        "Nazwa cechy": "",
        "Nazwa eksportu": "",
        "Nazwa elementu": "",
        "Nazwa etapu": "",
        "Nazwa firmy": "",
        "Nazwa grupy cech": "",
        "Nazwa grupy w panelu oraz jej wersje wyświetlane w sklepie.": "",
        "Nazwa grupy wyświetlana w panelu administracyjnym.": "",
        "Nazwa i identyfikator kolekcji produktów.": "",
        "Nazwa i okres obowiązywania wpisu.": "",
        "Nazwa i zasady działania grupy klientów.": "",
        "Nazwa katalogu": "",
        "Nazwa kategorii używana w panelu oraz jako domyślna nazwa wyświetlana.": "",
        "Nazwa klienta": "",
        "Nazwa kolekcji": "",
        "Nazwa parametru": "",
        "Nazwa pokazywana klientowi w wybranym języku.": "",
        "Nazwa powiadomienia": "",
        "Nazwa prezentowana klientom sklepu. Uzupełnij ją osobno dla każdego języka.": "",
        "Nazwa prezentowana klientom. Uzupełnij ją osobno dla każdego języka.": "",
        "Nazwa producenta": "",
        "Nazwa producenta i jego widoczność w sklepie.": "",
        "Nazwa produktu": "",
        "Nazwa promocji": "",
        "Nazwa promocji wiązanej": "",
        "Nazwa przeceny": "",
        "Nazwa sklepu": "",
        "Nazwa sposobu dostawy": "",
        "Nazwa sposobu płatności": "",
        "Nazwa stawki i domyślna reguła dla produktów.": "",
        "Nazwa systemowa": "",
        "Nazwa ułatwiająca rozpoznanie grupy cech w panelu.": "",
        "Nazwa ułatwiająca rozpoznanie metody dostawy w panelu.": "",
        "Nazwa ułatwiająca rozpoznanie wpisu w kalendarzu.": "",
        "Nazwa użytkownika": "",
        "Nazwa używana do rozpoznania cechy w panelu administracyjnym.": "",
        "Nazwa widoczna na liście sklepów i w panelu administracyjnym.": "",
        "Nazwa widoczna w sklepie": "",
        "Nazwa wpisu do kalendarza": "",
        "Nazwa wyświetlana": "",
        "Nazwa, adres i treść kategorii.": "",
        "Nazwa, dostępność i treści prezentowane klientom sklepu.": "",
        "Nazwa, identyfikator i waluta kraju.": "",
        "Nazwa, priorytet i okres wyświetlania etykiety.": "",
        "Nazwa, sklep i zakres działania promocji.": "",
        "Nazwa, widoczność i opis metody dostawy w sklepie.": "",
        "Nazwisko": "",
        "Nazwisko klienta": "",
        "Nazwy": "",
        "Nazwy i opis identyfikujący produkt w katalogu.": "",
        "Nazwy, grupa i zasady uzupełniania cechy w produktach.": "",
        "Netto": "",
        "Nie": "",
        "Nie dodano jeszcze żadnej cechy.": "",
        "Nie działa jedna z funkcji produktu": "",
        "Nie importuj": "",
        "Nie pozwól": "",
        "Nie przypisano jeszcze żadnej kategorii.": "",
        "Nie przypisano kolekcji.": "",
        "Nie przypisano żadnej etykiety.": "",
        "Nie udało się odczytać pliku CSV.": "",
        "Nie udało się pobrać cech kategorii.": "",
        "Nie udało się pobrać listy kategorii.": "",
        "Nie udało się pobrać reklamacji.": "",
        "Nie udało się przeszukać kategorii.": "",
        "Nie udało się rozpocząć importu kategorii.": "",
        "Nie udało się rozpocząć importu produktów.": "",
        "Nie udało się skopiować danych do schowka.": "",
        "Nie udało się wczytać cech produktu.": "",
        "Nie udało się wczytać cech.": "",
        "Nie udało się wczytać cechy.": "",
        "Nie udało się wczytać cennika.": "",
        "Nie udało się wczytać części danych pomocniczych.": "",
        "Nie udało się wczytać członków grupy.": "",
        "Nie udało się wczytać danych klienta.": "",
        "Nie udało się wczytać dostaw dla wybranego sklepu.": "",
        "Nie udało się wczytać eksportu.": "",
        "Nie udało się wczytać etykiet.": "",
        "Nie udało się wczytać faktur.": "",
        "Nie udało się wczytać faktury.": "",
        "Nie udało się wczytać formularza. Spróbuj ponownie.": "",
        "Nie udało się wczytać grup cech.": "",
        "Nie udało się wczytać grup klientów.": "",
        "Nie udało się wczytać grupy cech.": "",
        "Nie udało się wczytać grupy klientów.": "",
        "Nie udało się wczytać historii cen.": "",
        "Nie udało się wczytać historii wersji.": "",
        "Nie udało się wczytać katalogów.": "",
        "Nie udało się wczytać kategorii.": "",
        "Nie udało się wczytać klientów.": "",
        "Nie udało się wczytać kodów.": "",
        "Nie udało się wczytać kolekcji.": "",
        "Nie udało się wczytać konfiguracji wariantów.": "",
        "Nie udało się wczytać krajów.": "",
        "Nie udało się wczytać listy.": "",
        "Nie udało się wczytać nazw powiązanych elementów.": "",
        "Nie udało się wczytać nazw produktów.": "",
        "Nie udało się wczytać notatek.": "",
        "Nie udało się wczytać opinii.": "",
        "Nie udało się wczytać podatków.": "",
        "Nie udało się wczytać pól źródła danych.": "",
        "Nie udało się wczytać producentów.": "",
        "Nie udało się wczytać produktów zestawu.": "",
        "Nie udało się wczytać produktów.": "",
        "Nie udało się wczytać produktu.": "",
        "Nie udało się wczytać promocji.": "",
        "Nie udało się wczytać przypisanych cech.": "",
        "Nie udało się wczytać sklepów.": "",
        "Nie udało się wczytać sklepu.": "",
        "Nie udało się wczytać sposobów dostawy.": "",
        "Nie udało się wczytać sposobów płatności.": "",
        "Nie udało się wczytać sposobu dostawy.": "",
        "Nie udało się wczytać sposobu płatności.": "",
        "Nie udało się wczytać ustawień generowania kodów.": "",
        "Nie udało się wczytać ustawień.": "",
        "Nie udało się wczytać walut.": "",
        "Nie udało się wczytać wariantów.": "",
        "Nie udało się wczytać wartości cechy.": "",
        "Nie udało się wczytać zamówień.": "",
        "Nie udało się wczytać zamówienia.": "",
        "Nie udało się wczytać zgłoszenia.": "",
        "Nie udało się wczytać zwrotów.": "",
        "Nie udało się zapisać kolejności. Spróbuj ponownie.": "",
        "Nie uwzględniaj dla produktów z dostawą na palecie": "",
        "Nie uzupełniono": "",
        "Nie wybrano pliku": "",
        "Nie wybrano żadnej opinii.": "",
        "Nie wybrano żadnych etykiet.": "",
        "Nie zawiera": "",
        "Nie znaleziono wybranego produktu.": "",
        "Nieaktywna": "",
        "Nieaktywna kolekcja nie jest widoczna w sklepie.": "",
        "Nieaktywne": "",
        "Niekompletny zestaw / brak akcesoriów": "",
        "Niektóre wersje językowe zostały już przypisane do innych sklepów.": "",
        "Nielimitowana": "",
        "Niestandardowa wiadomość": "",
        "NIP": "",
        "Notatka": "",
        "Notatka administracyjna": "",
        "Notatka administracyjna została zapisana.": "",
        "Notatka została usunięta.": "",
        "Notatka została zapisana.": "",
        "Notatki": "",
        "Nowa cecha": "",
        "Nowa etykieta": "",
        "Nowa faktura": "",
        "Nowa grupa cech": "",
        "Nowa grupa klientów": "",
        "Nowa kolekcja": "",
        "Nowa opcja dostawy": "",
        "Nowa promocja wiązana": "",
        "Nowa przecena": "",
        "Nowa stawka podatku": "",
        "Nowa waluta": "",
        "Nowe": "",
        "Nowe powiadomienie": "",
        "Nowe warianty": "",
        "Nowe zgłoszenie": "",
        "Nowy eksport": "",
        "Nowy kod rabatowy": "",
        "Nowy kraj": "",
        "Nowy parametr UTM": "",
        "Nowy producent": "",
        "Nowy produkt": "",
        "Nowy sklep": "",
        "Nowy sposób płatności": "",
        "Nowy wpis w kalendarzu": "",
        "np. Apple A19 Pro": "",
        "np. Podzespoły": "",
        "np. Procesor": "",
        "np. Sklep główny": "",
        "Numer": "",
        "Numer budynku": "",
        "Numer domu / mieszkania": "",
        "Numer faktury": "",
        "Numer kierunkowy": "",
        "Numer konta": "",
        "Numer reklamacji": "",
        "Numer zamówienia": "",
        "Numer zgłoszenia": "",
        "Numer zwrotu": "",
        "Obiekt": "",
        "Ocena": "",
        "Ocena do": "",
        "Ocena od": "",
        "Oceniony produkt": "",
        "Oczekujące": "",
        "Oczekujący na publikację": "",
        "Oczekuje na płatność": "",
        "Oczekuje na wysłanie": "",
        "Odbiór osobisty": "",
        "Odbiorca": "",
        "Odbiorca (firma)": "",
        "Oddziel kolejne wartości przecinkami.": "",
        "Odpiąć cechę od grupy? Cecha pozostanie w katalogu.": "",
        "Odrzucone": "",
        "Odrzucony": "",
        "Odstęp góra i dół": "",
        "Odstęp lewa i prawa": "",
        "Odstępy i obramowanie": "",
        "Ogólne": "",
        "Okres działania i powtarzające się przedziały godzinowe.": "",
        "Okres przechowywania historii przeglądanych produktów.": "",
        "Określ czas przechowywania nieaktywnych koszyków.": "",
        "Określ ilość produktu pozostawianą w magazynie.": "",
        "Określ miejsce kategorii w katalogu.": "",
        "Określ terminy dostępności formularzy zgłoszeń po zrealizowaniu zamówienia.": "",
        "Określ zasady zamawiania dla niezalogowanych klientów i produktów bez dostępnego zapasu.": "",
        "Określa, czy klient może zamówić produkt mimo braku dostępnego zapasu.": "",
        "Opcja przeliczenia": "",
        "Opcje dokumentu": "",
        "Opcje elementu": "",
        "Opcjonalna grafika reprezentująca wartość tekstową cechy. Wybierz jeden plik.": "",
        "Operacja spowoduje trwałe usunięcie wszystkich kategorii należących do tego katalogu! Czy na pewno chcesz wykonać akcję?": "",
        "Operator": "",
        "Operator lub moduł obsługujący tę metodę dostawy.": "",
        "Opinia": "",
        "Opinia została usunięta.": "",
        "Opinia została zaktualizowana.": "",
        "Opinie": "",
        "Opinie produktowe": "",
        "Opinie zostały zaktualizowane": "",
        "Ogranicz produkty uwzględnione w feedzie.": "",
        "Opinii na stronie": "",
        "Opis": "",
        "Opis grupy": "",
        "Opis produktu": "",
        "Opis wady": "",
        "Opis wartości": "",
        "Opis został wygenerowany": "",
        "Opisy": "",
        "Opisy prezentowane w sklepie w poszczególnych językach.": "",
        "Opisz, jakich klientów obejmuje grupa i do czego służy.": "",
        "Opłacona": "",
        "Opłacone": "",
        "Opłacono": "",
        "Opublikowany": "",
        "Oraz (and)": "",
        "Osoba fizyczna": "",
        "Ostatni miesiąc": "",
        "Ostatni rok": "",
        "Ostatnia aktualizacja:": "",
        "Ostatnia modyfikacja": "",
        "Ostatnie 24h": "",
        "Ostatnie 7 dni": "",
        "Ostatnie 90 dni": "",
        "Ostrzeżenie": "",
        "Otrzymałem(-am) inny produkt niż zamówiony": "",
        "Otrzymałem(-am) niewłaściwy produkt": "",
        "Oznaczenie metody dostawy i powiązane formy płatności.": "",
        "Oznaczenie wyświetlane przy kwotach, np. zł lub €.": "",
        "Parametr UTM": "",
        "Parametr UTM został dodany.": "",
        "Parametr UTM został zaktualizowany.": "",
        "Parametr został usunięty.": "",
        "Parametry logistyczne": "",
        "Parametry przesyłki używane podczas realizacji zamówienia.": "",
        "Parametry UTM": "",
        "PayPal": "",
        "PayU": "",
        "Pełna treść strony produktu w poszczególnych językach.": "",
        "Pierwszy wiersz jest nagłówkiem": "",
        "PIN": "",
        "Planowana data publikacji": "",
        "Płatność": "",
        "Płatność przy odbiorze": "",
        "płatność wyłączona": "",
        "Płatność za pobraniem": "",
        "Płatności": "",
        "Plik CSV": "",
        "Plik CSV nie zawiera danych.": "",
        "Plik faktury": "",
        "Pliki udostępniane z kolekcją.": "",
        "Po tym czasie nieaktywny koszyk zostanie usunięty.": "",
        "Po wyłączeniu każda nowa opinia wymaga ręcznego zatwierdzenia.": "",
        "Po zapisaniu promocji nie można zmienić efektów.": "",
        "Po zapisaniu promocji nie można zmienić efektu.": "",
        "Po zapisaniu promocji nie można zmienić sklepu.": "",
        "Po zapisaniu promocji nie można zmienić typu kodu.": "",
        "Po zmianie stawki podatku możesz przeliczyć ceny produktów, zachowując przy tym cenę netto lub brutto. Zachowanie ceny netto przelicza cenę brutto, a zachowanie ceny brutto przelicza cenę netto zgodnie z nową wartością przypisanego podatku.": "",
        "Pobiera koszyki według obecności adresu email i czasu od porzucenia. Możesz wybrać kilka okresów jednocześnie.": "",
        "Pobierz etykietę": "",
        "Pobierz etykiety": "",
        "Pobranie": "",
        "Pobranie kodu promocyjnego": "",
        "Pobranie koszyków": "",
        "Pochylenie": "",
        "Podatek": "",
        "Podatki": "",
        "Podatki zostały zaktualizowane": "",
        "Podgląd": "",
        "Podgląd kategorii": "",
        "Podgląd kodu": "",
        "Podgląd na jasnym i ciemnym tle sklepu.": "",
        "Podgląd zdjęcia produktu": "",
        "Podkreślenie": "",
        "Podstawowe informacje": "",
        "Podstawowe informacje o złożonym zamówieniu.": "",
        "Podsumowanie": "",
        "Podsumowanie opinii": "",
        "Podsumowanie opinii klientów (AI)": "",
        "Pogrubienie": "",
        "Pokaż atrybut": "",
        "Pokaż kafelki do ostatniego poziomu": "",
        "Pokaż kafelki do wybranego poziomu": "",
        "Pola z wybranego formularza pojawią się w zgłoszeniu reklamacyjnym.": "",
        "Pole \"Liczba wyników\" jest wymagane.": "",
        "Pole \"Promocja\" jest wymagane.": "",
        "Pole \"Sklep\" jest wymagane.": "",
        "Pole \"Sposób prezentacji wartości\" jest wymagane.": "",
        "Pole \"Tryb wyświetlania\" jest wymagane.": "",
        "Pole \"Typ\" jest wymagane.": "",
        "Pole \"Witryna\" jest wymagane.": "",
        "Pole dziedziczone z produktu bazowego.": "",
        "Pole z modelu": "",
        "Pomyłka przy zakupie": "",
        "Poprzedni okres": "",
        "Porzucone koszyki": "",
        "Posiada wagę": "",
        "Posiada zdjęcie": "",
        "Potwierdzenie dezaktywacji": "",
        "Potwierdzenie kopiowania": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdzenie usunięcia. Wykonanie tej akcji nie usunie cechy przypisanej do produktów.": "",
        "Powiadomienia": "",
        "Powiadomienie": "",
        "Powiadomienie do zamówienia": "",
        "Powiadomienie zostało dodane.": "",
        "Powiadomienie zostało usunięte.": "",
        "Powiadomienie zostało zaktualizowane.": "",
        "Powód": "",
        "Powód dezaktywacji": "",
        "Powód dezaktywacji ceny": "",
        "Powód reklamacji": "",
        "Poziom kategorii": "",
        "Pozostałe parametry": "",
        "Pozostałe zdjęcia": "",
        "Pozostało do zapłaty": "",
        "Pozostało do zapłaty: {amount}": "",
        "Pozwól": "",
        "Pozycje zamówienia i ich wartości.": "",
        "Pozytywna": "",
        "Prawda": "",
        "Prawda/Fałsz": "",
        "Priorytet": "",
        "Procentowy": "",
        "Producenci": "",
        "Producent": "",
        "Producent aktywny": "",
        "Producent został dodany.": "",
        "Producent został usunięty.": "",
        "Producent został zaktualizowany.": "",
        "Produkt": "",
        "Produkt bazowy": "",
        "Produkt dodawany jako gratis po spełnieniu progu.": "",
        "Produkt dodawany jako gratis.": "",
        "Produkt dotarł uszkodzony": "",
        "Produkt dotarł za późno": "",
        "Produkt jest niezgodny z opisem": "",
        "Produkt ma wadę fabryczną": "",
        "Produkt nie działa / działa nieprawidłowo": "",
        "Produkt nie spełnia oczekiwań": "",
        "Produkt nosi ślady użytkowania": "",
        "Produkt o statusie Oczekujący na publikację zostanie opublikowany po tej dacie.": "",
        "Produkt posiada warianty": "",
        "Produkt rekomendowany": "",
        "Produkt uszkodzony po dostawie": "",
        "Produkt wygląda inaczej niż na zdjęciach": "",
        "Produkt wymaga transportu na palecie.": "",
        "Produkt został dodany.": "",
        "Produkt został skopiowany.": "",
        "Produkt został usunięty.": "",
        "Produkt został zaktualizowany.": "",
        "Produkty": "",
        "Produkty komplementarne": "",
        "Produkty objęte indywidualnymi kodami.": "",
        "Produkty otagowane": "",
        "Produkty polecane razem z aktualnym produktem.": "",
        "Produkty rekomendowane": "",
        "Produkty uwzględnione": "",
        "Produkty uwzględnione w promocji": "",
        "Produkty uzupełniające ofertę aktualnego produktu.": "",
        "Produkty w kolekcji": "",
        "Produkty w promocji": "",
        "Produkty wraz z wariantami": "",
        "Produkty zostały usunięte z systemu": "",
        "Produkty zostały zaktualizowane": "",
        "Próg ilościowy": "",
        "Promocja": "",
        "Promocja jest w trakcie działania. Możesz zmienić jej nazwę i aktywność; pozostałe parametry są zablokowane.": "",
        "Promocja obowiązuje tylko w wybranych godzinach każdego dnia.": "",
        "Promocja wiązana": "",
        "Promocja wiązana została usunięta.": "",
        "Promocja włączona": "",
        "Promocja została dodana.": "",
        "Promocja została usunięta.": "",
        "Promocja została zaktualizowana.": "",
        "Promocje": "",
        "Promocje wiązana": "",
        "Promocje wiązane": "",
        "Protokół OAuth - client_id": "",
        "Protokół OAuth - client_secret": "",
        "Przecena produktów": "",
        "Przecena zamówienia": "",
        "Przeceny": "",
        "Przeceny produktów": "",
        "Przeciągnij cechy, aby ustalić kolejność ich wyświetlania.": "",
        "Przeciągnij grupy cech, aby ustalić kolejność ich wyświetlania.": "",
        "Przeciągnij uchwyt, aby zmienić kolejność. Możesz też użyć klawiatury: Spacja, strzałki i Enter.": "",
        "Przeciągnij wartości, aby ustalić kolejność ich wyświetlania.": "",
        "Przedrostek": "",
        "Przekreślenie": "",
        "Przelew tradycyjny": "",
        "Przelewy24": "",
        "Przelicz": "",
        "Przelicz podatek": "",
        "Przelicz podatki": "",
        "Przenieś wartość {name}": "",
        "Przewidywany czas realizacji dostawy.": "",
        "Przypisane kategorie": "",
        "Przypisany": "",
        "Przypisuj użytkowników do grupy i zarządzaj jej członkami.": "",
        "Przypisz cechę do grupy, aby uporządkować parametry produktów.": "",
        "Przypisz cechy produktów i sprawdź cechy odziedziczone.": "",
        "Przypisz cechy, które mają należeć do tej grupy.": "",
        "Przypisz sklep do wersji językowych witryn.": "",
        "Przyrostek": "",
        "Publikacja": "",
        "Publikuj do": "",
        "Publikuj od": "",
        "Rabat": "",
        "Rabaty": "",
        "Reguła podatkowa stosowana do kosztu dostawy.": "",
        "Reguła podatku": "",
        "Reklamacja": "",
        "Reklamacje": "",
        "reklamacje / zamówienia": "",
        "Reklamacje i zwroty": "",
        "Rekomendacja": "",
        "Rezerwacja stanów magazynowych": "",
        "Rezerwacje magazynowe": "",
        "Rodzaj kodu": "",
        "Rodzaj płatności": "",
        "Równe": "",
        "Rozliczenie": "",
        "Rozliczenie faktury": "",
        "Rozliczenie powiązanego zamówienia.": "",
        "Rozmiar i waga paczki": "",
        "Rozmiar nie pasuje": "",
        "Rozmiar, styl i dekoracje tekstu.": "",
        "Różne": "",
        "Rozpoczęto checkout": "",
        "Ścieżki": "",
        "Secret ID": "",
        "Sesje": "",
        "Siatka": "",
        "Sklep": "",
        "Sklep został dodany.": "",
        "Sklep został usunięty.": "",
        "Sklep został zaktualizowany.": "",
        "Sklepy": "",
        "Skonfiguruj zawartość": "",
        "Skopiowano": "",
        "Skopiowano do schowka.": "",
        "SKU": "",
        "Slider": "",
        "Słowa kluczowe": "",
        "Słowa opisujące kategorię. Możesz oddzielić je przecinkami.": "",
        "Sortowanie cech": "",
        "Sortowanie grup cech": "",
        "Sortowanie wartości": "",
        "Sortowanie wartości cechy": "",
        "Sortuj": "",
        "Sortuj cechy": "",
        "Sortuj grupy cech": "",
        "Sposób dostawy": "",
        "Sposób dostawy włączony": "",
        "Sposób dostawy został dodany.": "",
        "Sposób dostawy został usunięty.": "",
        "Sposób dostawy został zaktualizowany.": "",
        "Sposób łączenia warunków": "",
        "Sposób płatności": "",
        "Sposób płatności włączony": "",
        "Sposób płatności został dodany.": "",
        "Sposób płatności został usunięty.": "",
        "Sposób płatności został zaktualizowany.": "",
        "Sposób prezentacji cen": "",
        "Sposób prezentacji wartości": "",
        "Sposób przekazania przesyłki klientowi.": "",
        "Sposób wyświetlania": "",
        "Sposób wyświetlania kafelków kategorii": "",
        "Spróbuj ponownie": "",
        "Sprzedaż": "",
        "Sprzedaż brutto": "",
        "Sprzedaż całkowita": "",
        "Sprzedaż netto": "",
        "Średnia": "",
        "Środowisko": "",
        "Środowisko testowe lub produkcyjne integracji.": "",
        "Stały": "",
        "Stan magazynowy": "",
        "Stan magazynu": "",
        "Standalone": "",
        "Standardowy": "",
        "Status": "",
        "Status (Draft, WaitingForPublication, Published)": "",
        "Status dostawy": "",
        "Status faktury": "",
        "Status i wartość zamówienia.": "",
        "Status koszyka": "",
        "Status kupującego": "",
        "Status opinii": "",
        "Status płatności": "",
        "Status reklamacji został zmieniony.": "",
        "Status zamówienia": "",
        "Status zwrotu został zmieniony.": "",
        "Stawka domyślna": "",
        "Stawka podatku": "",
        "Stawka została dodana.": "",
        "Stawka została usunięta.": "",
        "Stawka została zaktualizowana.": "",
        "Stawki podatkowe obowiązujące w wybranym kraju.": "",
        "Stawki podatku w poszczególnych państwach": "",
        "Stosowana dla produktów bez własnej reguły podatku.": "",
        "Strefa czasowa": "",
        "Strefa czasowa używana przez sklep przy obsłudze dat i godzin.": "",
        "Strona producenta": "",
        "Struktura dokumentu": "",
        "Styl dekoracji tekstu": "",
        "Styl obramowania": "",
        "Sugerowane ceny": "",
        "Suma cen produktów od której naliczany jest rabat (brutto)": "",
        "Symbol": "",
        "Symbol identyfikujący ten zakres cen dostawy.": "",
        "Symbol kategorii": "",
        "Symbol kolekcji": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -.": "",
        "Symbol może składać się z małych liter, cyfr oraz znaku -.": "",
        "Symbol może zawierać małe litery, cyfry i znak -.": "",
        "Symbol produktu": "",
        "Synchronizuj": "",
        "System opinii": "",
        "System opinii włączony": "",
        "Szablon": "",
        "Szczegółowe informacje o producencie w poszczególnych językach.": "",
        "Szczegóły faktury": "",
        "Szczegóły klienta": "",
        "Szczegóły kolekcji": "",
        "Szczegóły opinii": "",
        "Szczegóły reklamacji": "",
        "Szczegóły zamówienia": "",
        "Szczegóły zgłoszenia": "",
        "Szczegóły zwrotu": "",
        "Szerokość": "",
        "Szerokość paczki": "",
        "Szkic": "",
        "szt": "",
        "szt.": "",
        "Szukaj kategorii": "",
        "Szukaj kategorii…": "",
        "Ta forma dostawy jest wyłączona": "",
        "Tabela": "",
        "Tak": "",
        "Tekst": "",
        "Tekst wyświetlany podczas ustawienia blokady": "",
        "Telefon": "",
        "Temat": "",
        "Ten moduł nie wymaga dodatkowej konfiguracji webservice.": "",
        "Token API ShipX": "",
        "Token dostępu do API obsługującego przesyłki InPost.": "",
        "Token Geowidget": "",
        "Token mapy punktów odbioru InPost.": "",
        "tPay": "",
        "Treść": "",
        "Treść notatki": "",
        "Treść opinii": "",
        "Treść prezentowana klientom sklepu.": "",
        "Trwa generowanie opisu": "",
        "Tryb wyświetlania": "",
        "Trzyliterowy kod waluty, np. PLN lub EUR.": "",
        "Tworzenie cennika": "",
        "Tworzenie faktury": "",
        "Tworzenie wariantów": "",
        "Typ": "",
        "Typ (Standard, Pack)": "",
        "Typ danych": "",
        "Typ danych listy": "",
        "Typ dostawy": "",
        "Typ elementu": "",
        "Typ kodu i ograniczenia jego wykorzystania.": "",
        "Typ notatki": "",
        "Typ parametru UTM": "",
        "Typ produktu i jego dostępność na stronie.": "",
        "Typ rabatu": "",
        "Typ widgetu": "",
        "Typografia": "",
        "Typu nie można zmienić po utworzeniu.": "",
        "Udział procentowy": "",
        "Ukryj atrybut": "",
        "Ukryj kafelki": "",
        "Ukryj kafelki lub pokaż je do ostatniego albo wskazanego poziomu kategorii.": "",
        "Ulica": "",
        "URL płatności": "",
        "Ustal, jak długo i ile ostatnio oglądanych produktów ma pozostać w historii klienta.": "",
        "Ustaw czas rezerwacji produktów oraz minimalny i maksymalny poziom logistyczny.": "",
        "Ustaw priorytet względem innych grup klientów.": "",
        "Ustaw procentową stawkę dla każdego kraju.": "",
        "Ustaw sposób wyświetlania i akceptowania opinii produktów.": "",
        "Ustaw status": "",
        "Ustawienia cechy": "",
        "Ustawienia darmowego produktu": "",
        "Ustawienia darmowej dostawy": "",
        "Ustawienia domyślne": "",
        "Ustawienia eksportu": "",
        "Ustawienia kategorii": "",
        "Ustawienia kodu pocztowego": "",
        "Ustawienia kodu rabatowego": "",
        "Ustawienia listy": "",
        "Ustawienia podatku": "",
        "Ustawienia podstawowe": "",
        "Ustawienia produktu": "",
        "Ustawienia rabatu": "",
        "Ustawienia sklepu": "",
        "Ustawienia sposobu dostawy": "",
        "Ustawienia sposobu płatności": "",
        "Ustawienia webservice": "",
        "Ustawienia zostały zapisane.": "",
        "Usuń": "",
        "Usuń atrybut": "",
        "Usuń cechę": "",
        "Usuń element": "",
        "Usuń etykietę": "",
        "Usuń katalog": "",
        "Usuń kategorię": "",
        "Usuń notatkę": "",
        "Usuń powiązanie": "",
        "Usuń producenta": "",
        "Usuń produkt z kolekcji": "",
        "Usuń produkt z promocji": "",
        "Usuń wartość": "",
        "Usuń warunek": "",
        "Usun właściwość": "",
        "Usuń z grupy": "",
        "Usuń z zestawu": "",
        "Usuń zakres": "",
        "Usunąć ten zakres cen dostawy?": "",
        "Utwórz": "",
        "Utworzona": "",
        "Utworzono": "",
        "Uzupełnij wymagane mapowanie pliku CSV.": "",
        "Uzupełniono": "",
        "Użycia": "",
        "Użytkownik": "",
        "Użytkownik został odpięty od grupy klientów.": "",
        "Użytkownik został przypisany do grupy klientów.": "",
        "Użyty": "",
        "vs poprzedni okres": "",
        "W magazynie": "",
        "W temacie i treści wiadomości można korzystać z systemu szablonów języka Liquid do parsowania danych pochodzących z zamówienia.": "",
        "W trakcie realizacji": "",
        "W trakcie rozpatrywania": "",
        "Waga": "",
        "Waga paczki": "",
        "Waga produktu": "",
        "Waga produktu w kilogramach.": "",
        "Waga przygotowanej paczki w kilogramach.": "",
        "Waluta": "",
        "Waluta rozliczeń sklepu. Jej zmiana wymaga ponownego wyboru kraju.": "",
        "Waluta została dodana.": "",
        "Waluta została usunięta.": "",
        "Waluta została zaktualizowana.": "",
        "Waluty": "",
        "Wariant produktu": "",
        "Wariant został usunięty.": "",
        "Warianty": "",
        "Warianty dodane: {count}": "",
        "Warianty produktu zostały utworzone.": "",
        "Warianty usunięte: {count}": "",
        "Wartość": "",
        "Wartość numeryczna": "",
        "Wartość przed doliczeniem kosztów dostawy (brutto).": "",
        "Wartość rabatu": "",
        "Wartość rabatu (brutto)": "",
        "Wartość tekstowa": "",
        "Wartość wybierana przy uzupełnianiu cechy produktu. Przygotuj jej wersje językowe.": "",
        "Wartość wymagana": "",
        "Wartość z modelu": "",
        "Wartość zamówień": "",
        "Wartość została dodana.": "",
        "Wartość została usunięta.": "",
        "Wartość została zaktualizowana.": "",
        "Wartości": "",
        "Wartości cechy": "",
        "Wartości numeryczne": "",
        "Wartości procentowe lub kwoty brutto w walucie sklepu.": "",
        "Wartości są liczbami całkowitymi. Typ można wybrać tylko podczas tworzenia cechy.": "",
        "Warunki": "",
        "Warunki wyświetlania atrybutu": "",
        "Ważna": "",
        "Wczytaj": "",
        "Wczytaj cechy ponownie": "",
        "Wczytanie kategorii zastąpi bieżącą listę produktów.": "",
        "Wczytano dane z pliku CSV.": "",
        "Wczytywanie kategorii": "",
        "Wersja (version)": "",
        "Wersja API": "",
        "Wewnętrzne informacje dotyczące obsługi zamówienia.": "",
        "Wiadomość": "",
        "Widget służy do pobierania kodów promocyjnych z wybranej promocji.": "",
        "Widget służy do wczytania treści powiadomienia według wybranej statusu i wersji językowej.": "",
        "Widoczność i położenie": "",
        "Widoczność produktu w modułach z rekomendacjami.": "",
        "Większe lub równe": "",
        "Większe niż": "",
        "Wielkość obramowania": "",
        "Wielkość tekstu": "",
        "Wiersze do importu:": "",
        "Witryna": "",
        "Witryna i język": "",
        "Witryny": "",
        "Wklej pełną konfigurację eksportu (name, locale, websiteId, source, format, schema).": "",
        "Wklejony tekst nie jest poprawnym JSON.": "",
        "Włącz dni wysyłki i wskaż godzinę dla każdego z nich.": "",
        "Włącz dodatkowe pola dla reklamacji": "",
        "Włącz dostępność metody płatności w krajach i określ jej koszt.": "",
        "Włącz, aby w polu daty określić także godzinę rozpoczęcia i zakończenia.": "",
        "Właściwości": "",
        "Własna wartość": "",
        "Własny przedział": "",
        "Wpis aktywny": "",
        "Wpis aktywny: {name}": "",
        "Wpis do kalendarza": "",
        "Wpis do kalendarza został usunięty.": "",
        "Wpis do kalendarza został zaktualizowany.": "",
        "Wpis w kalendarzu został dodany.": "",
        "Wpis w kalendarzu został zaktualizowany.": "",
        "Wpisz liczbę całkowitą. Wartość może być również zerowa lub ujemna.": "",
        "Wpisz treść notatki, maksymalnie 255 znaków.": "",
        "Wpisz wartości po przecinku.": "",
        "Wpływ na wariantowość produktu": "",
        "Wprowadź treść notatki widocznej tylko dla obsługi": "",
        "Wszystkie": "",
        "Wszystkie kategorie": "",
        "Wszystkie statusy": "",
        "Wszystkie wersje językowe zostały już przypisane do innych sklepów.": "",
        "Wszystko": "",
        "Wybierz": "",
        "Wybierz cechę": "",
        "Wybierz cechę i kliknij plus, aby dodać ją do listy. Zmiany przypisań zostaną utrwalone po zapisaniu grupy.": "",
        "Wybierz ceny brutto z podatkiem lub ceny netto bez podatku.": "",
        "Wybierz darmowy produkt": "",
        "Wybierz element": "",
        "Wybierz element do edycji klikając na niego w strukturze.": "",
        "Wybierz element, aby skonfigurować jego nazwę, wartość i warunki.": "",
        "Wybierz etykietę": "",
        "Wybierz etykietę produktu": "",
        "Wybierz etykietę, którą chcesz przypisać do produktów": "",
        "Wybierz etykiety dostępne w tym sklepie.": "",
        "Wybierz formularz uzupełniający zgłoszenie reklamacyjne.": "",
        "Wybierz katalog z systemu": "",
        "Wybierz katalogi używane w sklepie.": "",
        "Wybierz katalogi, z których sklep ma korzystać przy prezentacji kategorii.": "",
        "Wybierz kategorię": "",
        "Wybierz kategorię z przypisanymi cechami, aby uzupełnić ich wartości.": "",
        "Wybierz kategorię z systemu": "",
        "Wybierz kategorię, którą chcesz przypisać do produktów": "",
        "Wybierz kolekcję, którą chcesz przypisać do produktów": "",
        "Wybierz kolumnę.": "",
        "Wybierz kraj, aby zobaczyć dostępne dostawy.": "",
        "Wybierz opcję": "",
        "Wybierz opinie dla których chcesz wykonać akcje": "",
        "Wybierz plik CSV": "",
        "Wybierz początek i koniec okresu obowiązywania wpisu.": "",
        "Wybierz podatek z systemu": "",
        "Wybierz pozycję i kliknij plus, aby dodać ją do listy.": "",
        "Wybierz producenta": "",
        "Wybierz producenta i kliknij plus. Dodane pozycje są pomijane.": "",
        "Wybierz producenta, którego chcesz przypisać do produktów": "",
        "Wybierz produkt": "",
        "Wybierz produkty dla których chcesz wykonać akcje": "",
        "Wybierz produkty powiązane z tą kolekcją.": "",
        "Wybierz produkty wchodzące w skład zestawu i określ ich ilość.": "",
        "Wybierz sklep": "",
        "Wybierz status": "",
        "Wybierz status który chcesz przypisać do opinii": "",
        "Wybierz status, który chcesz ustawić w produktach": "",
        "Wybierz status...": "",
        "Wybierz wartość z listy lub podaj własną.": "",
        "Wybierz witrynę": "",
        "Wybierz zakres dat": "",
        "Wybierz zakres godzinowy": "",
        "Wybierz zamówienie z listy.": "",
        "Wybierz źródło": "",
        "Wybór strony do przekierowania": "",
        "Wybrana dostawa i stan przesyłki.": "",
        "Wybrana kolumna nie zawiera danych.": "",
        "Wybrana kolumna zawiera wartości inne niż liczby.": "",
        "Wybrana kolumna zawiera wartości z nieprawidłowym formatem daty.": "",
        "Wybrana metoda i rozliczenie płatności.": "",
        "Wybrane etykiety": "",
        "Wybrane pole jest tablicą wartości. W wygenerowanym pliku elementy zostaną połączone przecinkami.": "",
        "Wybrane produkty": "",
        "Wybrani producenci": "",
        "Wybranie etykiety produktu jest wymagane": "",
        "Wybranie formatu jest wymagane": "",
        "Wybranie kategorii jest wymagane": "",
        "Wybranie limitu jest wymagane": "",
        "Wybranie producenta jest wymagane": "",
        "Wybranie produktu jest wymagane": "",
        "Wybrano jedną opinię.": "",
        "Wybranych opinii: %0": "",
        "Wybranych produktów:": "",
        "Wyczyść cechę we wszystkich językach: {name}": "",
        "Wyczyść maksymalną wartość rabatu": "",
        "Wyczyść wartość cechy: {name}": "",
        "Wygenerowanie nowych kodów spowoduje usunięcie wszystkich istniejących kodów dla tej promocji. Usunięte kody są nieważne i nie można ich już użyć.": "",
        "Wygeneruj feed": "",
        "Wygeneruj z nazwy": "",
        "Wygląd etykiety dla wybranej wersji językowej.": "",
        "Wykres kołowy": "",
        "Wykres słupkowy poziomy": "",
        "Wyłącz wpis, aby nie był aktywny w wybranym okresie.": "",
        "Wyłącz, aby dezaktywować grupę bez jej usuwania.": "",
        "Wyłączenie ukrywa opinie w sklepie i blokuje dodawanie nowych.": "",
        "Wyłączona promocja nie działa niezależnie od daty.": "",
        "Wymaga uzupełnienia tej cechy w produktach, do których jest przypisana.": "",
        "Wymagalność i format adresu pocztowego.": "",
        "Wymagany kod pocztowy": "",
        "Wymiary etykiety oraz wygląd jej krawędzi.": "",
        "Wysłane": "",
        "Wysokość": "",
        "Wysokość paczki": "",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
        "Wystąpił problem podczas generowania opisu.": "",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "",
        "Wystawiona ocena": "",
        "Wyświetlaj zawartość jako CDATA": "",
        "Wyświetlanie pól": "",
        "Wyświetlenia produktu": "",
        "Wysyłka na palecie": "",
        "Wysyłka: {day}": "",
        "Wyszukaj cechę...": "",
        "Wyszukaj etykietę...": "",
        "Wyszukaj etykietę…": "",
        "Wyszukaj grupę cech…": "",
        "Wyszukaj i dodaj etykiety, które mają być dostępne w tym sklepie.": "",
        "Wyszukaj kategorię...": "",
        "Wyszukaj kolekcję...": "",
        "Wyszukaj kraj...": "",
        "Wyszukaj kraj…": "",
        "Wyszukaj podatek…": "",
        "Wyszukaj producenta...": "",
        "Wyszukaj producenta…": "",
        "Wyszukaj produkt...": "",
        "Wyszukaj produkt…": "",
        "Wyszukaj rodzaj płatności...": "",
        "Wyszukaj sklep...": "",
        "Wyszukaj sposób dostawy...": "",
        "Wyszukaj użytkownika...": "",
        "Wyszukaj walutę...": "",
        "Wzór kodu pocztowego": "",
        "Wzór kodu pocztowego, który będzie wyświetlany w komunikacie błędnej walidacji.": "",
        "z {amount}": "",
        "Z adresem email": "",
        "Zaakceptowane": "",
        "Zaakceptowany": "",
        "Zachowaj cenę brutto": "",
        "Zachowaj cenę netto": "",
        "Zachowanie przy braku towaru na stanie": "",
        "zacznij pisac aby wyszukac etykiete...": "",
        "zacznij pisać aby wyszukać kraj...": "",
        "zacznij pisac aby wyszukac producenta...": "",
        "zacznij pisać aby wyszukać promocję...": "",
        "zacznij pisać aby wyszukać sklep...": "",
        "zacznij pisać aby wyszukać walutę...": "",
        "zacznij pisac aby wyszukac wartość...": "",
        "zacznij pisac aby wyszukac właściwość...": "",
        "Zacznij pisać, aby wyszukać cechę…": "",
        "Zaczyna się od": "",
        "Zakończ edycję adresu": "",
        "Zakres": "",
        "Zakres dat wpisu": "",
        "Zakup": "",
        "Załączniki": "",
        "Załaduj": "",
        "Zamawianie bez rejestracji": "",
        "Zamówienia": "",
        "Zamówienia klienta": "",
        "Zamówienia: {count}": "",
        "Zamówienie": "",
        "Zamówienie firmowe": "",
        "Zamówienie wymaga uwagi": "",
        "Zamówienie wymaga uwagi. Otwórz je, aby sprawdzić szczegóły.": "",
        "Zamówienie złożone": "",
        "Zamówienie zostało zaktualizowane.": "",
        "Zamówiłem(-am) kilka wariantów i zostawiam tylko jeden": "",
        "Zapisane wersje dokumentu.": "",
        "Zapisuj logi": "",
        "Zapisz": "",
        "Zapisz cechę, aby dodać jej wartości.": "",
        "Zapisz grupę, aby dodać do niej klientów.": "",
        "Zapisz i wróć": "",
        "Zapisz kolejność": "",
        "Zapisz notatkę": "",
        "Zapisz promocję, aby zarządzać indywidualnymi kodami.": "",
        "Zapisz zmiany": "",
        "Zapłacono": "",
        "Zapłacono brutto": "",
        "Zarezerwowana ilość": "",
        "Zastąp produktami kategorii": "",
        "Zastosowanie konfiguracji usunie warianty niepasujące do wybranych wartości.": "",
        "Zastosuj": "",
        "Zawartość elementu": "",
        "Zawiera": "",
        "Zawiera produkt": "",
        "Zaznacz dostępne sposoby dostawy. Pod każdym widać przypisane formy płatności; nieaktywne dostawy pozostają zablokowane.": "",
        "Zaznacz wersje językowe witryn obsługiwane przez sklep. Wersje przypisane do innych sklepów są zablokowane.": "",
        "Zaznaczona kategoria jest kategorią główną produktu.": "",
        "Zdecyduj, na jakich poziomach katalogu klient zobaczy kafelki kategorii.": "",
        "Zdezaktywowany": "",
        "Zdjęcia": "",
        "Zdjęcie": "",
        "Zdjęcie główne": "",
        "Ze statusu": "",
        "Zestaw": "",
        "Zewnętrzna głębokość przygotowanej paczki w centymetrach.": "",
        "Zewnętrzna szerokość przygotowanej paczki w centymetrach.": "",
        "Zewnętrzna wysokość przygotowanej paczki w centymetrach.": "",
        "Zmiana statusu": "",
        "Zmiany zostały zapisane.": "",
        "Zmień kolejność wartości cechy": "",
        "Zmień nazwę katalogu": "",
        "Zmień status": "",
        "Zmodyfikowane przez": "",
        "Zniżka została usunięta.": "",
        "Zrealizowane": "",
        "Żródła": "",
        "Źródło": "",
        "Źródło (utm_source)": "",
        "Źródło danych": "",
        "Źródło pochodzenia statusu": "",
        "Źródło zdarzenia, temat i treść wiadomości.": "",
        "Zwolniono": "",
        "Zwrot": "",
        "Zwroty": "",
        "zwroty / zamówienia": "",
        "Zwykły tekst": ""
    }
};
